var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticStyle:{"max-height":"130px"},attrs:{"height":"130","width":"300","id":"tx-chart"}})
}
var staticRenderFns = []

export { render, staticRenderFns }